import { EyeOutlined } from '@ant-design/icons'
import { Button, Table, TableColumnsType, Tooltip } from 'antd'

import { numberFormat } from '../../../../../utils'
import { getStatusLabel } from '../constants'
import { IOrderReportBucket } from '../types'

interface Props {
  data: IOrderReportBucket[]
  isLoading?: boolean
  onSelectStatus?: (status?: string) => void
}

const ByStatusTable = ({ data, isLoading, onSelectStatus }: Props) => {
  const columns: TableColumnsType<IOrderReportBucket> = [
    {
      title: 'สถานะ',
      dataIndex: 'status',
      key: 'status',
      render: (status?: string) => getStatusLabel(status),
    },
    {
      title: 'จำนวนออเดอร์',
      dataIndex: 'count',
      key: 'count',
      align: 'right',
      render: (value: number) => numberFormat(value, 0),
    },
    {
      title: 'จำนวนชิ้น',
      dataIndex: 'quantity',
      key: 'quantity',
      align: 'right',
      render: (value: number) => numberFormat(value, 0),
    },
    {
      title: 'ยอด COD (฿)',
      dataIndex: 'codTotal',
      key: 'codTotal',
      align: 'right',
      render: (value: number) => numberFormat(value),
    },
    {
      title: 'ยอดโอน (฿)',
      dataIndex: 'transferTotal',
      key: 'transferTotal',
      align: 'right',
      render: (value: number) => numberFormat(value),
    },
    {
      title: 'ยอดรวม (฿)',
      dataIndex: 'grandTotal',
      key: 'grandTotal',
      align: 'right',
      render: (value: number) => numberFormat(value),
    },
    {
      title: 'ต้นทุนสินค้า (฿)',
      dataIndex: 'costTotal',
      key: 'costTotal',
      align: 'right',
      render: (value: number) => numberFormat(value),
    },
    {
      // แถวสถานะที่ไม่ใช่สำเร็จ (เช่น ยกเลิก) จะได้ 0 — ไม่เอายอดที่ยังไม่ปิดการขายมาคิดกำไร
      title: 'กำไรขั้นต้น (฿)',
      key: 'grossProfit',
      align: 'right',
      render: (_, record) =>
        numberFormat(
          (record.successTotal ?? 0) - (record.successCostTotal ?? 0),
        ),
    },
    {
      title: 'ยอดขาย (฿)',
      dataIndex: 'revenueTotal',
      key: 'revenueTotal',
      align: 'right',
      render: (value: number) => numberFormat(value),
    },
    {
      title: 'ได้รับจริง (฿)',
      dataIndex: 'netTotal',
      key: 'netTotal',
      align: 'right',
      render: (value: number) => numberFormat(value),
    },
    {
      title: 'ค่าธรรมเนียม (฿)',
      dataIndex: 'feeTotal',
      key: 'feeTotal',
      align: 'right',
      render: (value: number) => numberFormat(value),
    },
    {
      title: 'จ่ายแล้ว',
      dataIndex: 'settledCount',
      key: 'settledCount',
      align: 'right',
      render: (value: number) => numberFormat(value, 0),
    },
    {
      title: '',
      key: 'action',
      align: 'right',
      render: (_, record) =>
        onSelectStatus ? (
          <Tooltip title="ดูออเดอร์">
            <Button
              type="text"
              icon={<EyeOutlined style={{ color: '#8c8c8c' }} />}
              onClick={() => onSelectStatus(record.status)}
            />
          </Tooltip>
        ) : null,
    },
  ]

  return (
    <Table
      rowKey={(record) => record.status ?? 'unknown'}
      columns={columns}
      dataSource={data}
      loading={isLoading}
      pagination={false}
      scroll={{ x: 'max-content' }}
    />
  )
}

export default ByStatusTable
